import { combineReducers } from 'redux';
import addedCompany from './Companies/AddCompany';
import addCompanyGroupChange from './Companies/AddCompanyGroup';
import addEnterpriseGroupChange from './Companies/AddEnterpriseGroup';

const defaultCompaniesLoading = false;
const companiesLoading = (state = defaultCompaniesLoading, action) => {
  switch (action.type) {
    case 'GET_COMPANIES':
      return true;
    case 'GET_COMPANIES_SUCCESS':
    case 'GET_COMPANIES_ERROR':
      return false;
    default:
      return state;
  }
};

const defaultCompanyPriBoxes = [];
const companyPriBoxes = (state = defaultCompanyPriBoxes, action) => {
  switch (action.type) {
    case 'GET_PRI_BOXES_BY_COMPANY_SUCCESS':
      return action.boxes;
    default:
      return state;
  }
};


const defaultCompanySipBoxes = [];
const companySipBoxes = (state = defaultCompanySipBoxes, action) => {
  
  switch (action.type) {
    case 'GET_SIP_BOXES_BY_COMPANY_SUCCESS':
      return action.boxes;
    default:
      return state;
  }
};

const defaultDeleteCompanyID = null;
const deleteCompanyID = (state = defaultDeleteCompanyID, action) => {
  switch (action.type) {
    case 'DELETE_COMPANY_SHOW':
      return action.id;
    case 'DELETE_COMPANY_SUCCESS':
    case 'DELETE_COMPANY_CANCEL':
      return null;
    default:
      return state;
  }
};

const defaultDeleteCompanyShow = false;
const deleteCompanyShow = (state = defaultDeleteCompanyShow, action) => {
  switch (action.type) {
    case 'DELETE_COMPANY_SHOW':
      return true;
    case 'DELETE_COMPANY_CANCEL':
    case 'DELETE_COMPANY_SUCCESS':
      return false;
    default:
      return state;
  }
};

const defaultDeleteEnterpriseID = null;
const deleteEnterpriseID = (state = defaultDeleteEnterpriseID, action) => {
  switch (action.type) {
    case 'DELETE_ENTERPRISE_SHOW':
      return action.id;
    case 'DELETE_ENTERPRISE_SUCCESS':
    case 'DELETE_ENTERPRISE_CANCEL':
      return null;
    default:
      return state;
  }
};

const defaultDeleteEnterpriseShow = false;
const deleteEnterpriseShow = (state = defaultDeleteEnterpriseShow, action) => {
  switch (action.type) {
    case 'DELETE_ENTERPRISE_SHOW':
      return true;
    case 'DELETE_ENTERPRISE_CANCEL':
    case 'DELETE_ENTERPRISE_SUCCESS':
      return false;
    default:
      return state;
  }
};

const defaultAddCompanyShow = false;
const addCompanyShow = (state = defaultAddCompanyShow, action) => {
  switch (action.type) {
    case 'ADD_COMPANY_SHOW':
      return true;
    case 'ADD_COMPANY_CANCEL':
    case 'ADD_COMPANY_SUCCESS':
      return false;
    default:
      return state;
  }
};

const defaultAddCompanyGroupShow = false;
const addCompanyGroupShow = (state = defaultAddCompanyGroupShow, action) => {
  switch (action.type) {
    case 'ADD_COMPANY_GROUP_SHOW':
      return true;
    case 'ADD_COMPANY_GROUP_CANCEL':
    case 'ADD_COMPANY_GROUP_SUCCESS':
      return false;
    default:
      return state;
  }
};

const defaultAddEnterpriseGroupShow = false;
const addEnterpriseGroupShow = (state = defaultAddEnterpriseGroupShow, action) => {
  switch (action.type) {
    case 'ADD_ENTERPRISE_GROUP_SHOW':
      return true;
    case 'ADD_ENTERPRISE_GROUP_CANCEL':
    case 'ADD_ENTERPRISE_GROUP_SUCCESS':
      return false;
    default:
      return state;
  }
};

const defaultEditCompanyShow = false;
const editCompanyShow = (state = defaultEditCompanyShow, action) => {
  switch (action.type) {
    case 'EDIT_COMPANY_SHOW':
      return true;
    case 'EDIT_COMPANY_CANCEL':
    case 'EDIT_COMPANY_SUCCESS':
      return false;
    default:
      return state;
  }
};

const defaultEditCompanyGroupShow = false;
const editCompanyGroupShow = (state = defaultEditCompanyGroupShow, action) => {
  switch (action.type) {
    case 'EDIT_COMPANY_GROUP_SHOW':
      return true;
    case 'EDIT_COMPANY_GROUP_CANCEL':
    case 'EDIT_COMPANY_GROUP_SUCCESS':
      return false;
    default:
      return state;
  }
};

const defaultEditEnterpriseGroupShow = false;
const editEnterpriseGroupShow = (state = defaultEditEnterpriseGroupShow, action) => {
  switch (action.type) {
    case 'EDIT_ENTERPRISE_GROUP_SHOW':
      return true;
    case 'EDIT_ENTERPRISE_GROUP_CANCEL':
    case 'EDIT_ENTERPRISE_GROUP_SUCCESS':
      return false;
    default:
      return state;
  }
};

const defaultEditCompanyData = {
  name: '',
  enabled: false,
  companyType: '',
  permissions: {
    emailNotifications: true,
    showCallRecording: true,
    showFaxDownload: true,
  },
};
const editCompanyData = (state = defaultEditCompanyData, action) => {
  switch (action.type) {
    case 'EDIT_COMPANY_DATA':
      return action.data;
    default:
      return state;
  }
};

const defaultFilterByCompanyGroupManager = {
  groupManagerEmail: {
    emails: [],
  },
};
const filterByCompanyGroupManager = (state = defaultFilterByCompanyGroupManager, action) => {
  switch (action.type) {
    case 'COMPANY_GROUP_MANAGER_SUCCESS':
      return {
        ...state,
        groupManagerEmail: action.groupManagerEmail,
      };
    default:
      return state;
  }
};

const defaultFilterBySupportEngineer = {
  supportEngineerEmail: {
    emails: [],
  },
};
const filterBySupportEngineer = (state = defaultFilterBySupportEngineer, action) => {
  switch (action.type) {
    case 'COMPANY_SUPPORT_ENGINEERS_SUCCESS':
      return {
        ...state,
        groupSupportEngineer: action.groupSupportEngineer,
      };
    default:
      return state;
  }
};

const defaultEditCompanyGroupData = {};
const editCompanyGroupData = (state = defaultEditCompanyGroupData, action) => {
  switch (action.type) {
    case 'CLEAR_EDIT_COMPANY_GROUP_DATA':
      return defaultEditCompanyGroupData;
    case 'EDIT_COMPANY_GROUP_DATA':
      return action.data;
    default:
      return state;
  }
};

const defaultEditEnterpriseGroupData = {};
const editEnterpriseGroupData = (state = defaultEditEnterpriseGroupData, action) => {
  switch (action.type) {
    case 'CLEAR_EDIT_ENTERPRISE_GROUP_DATA':
      return defaultEditEnterpriseGroupData;
    case 'EDIT_ENTERPRISE_GROUP_DATA':
      return action.data;
    default:
      return state;
  }
};

const defaultGetAllEmailCompany = [];
const getAllEmailCompany = (state = defaultGetAllEmailCompany, action) => {
  switch (action.type) {
    case 'ALL_NUMBERS_SUCCESS':
      return action.numbers;
    default:
      return state;
  }
};

const defaultCompanyAgency = {};
const companyAgency = (state = defaultCompanyAgency, action) => {
  switch (action.type) {
    case 'GET_COMPANY_AGENCY_SUCCESS':
      return { ...action.companyAgency };
    default:
      return state;
  }
};

const defaultgetLogo = '';
const getLogo = (state = defaultgetLogo, action) => {
  switch (action.type) {
    case 'GET_COMPANY_LOGO_SUCCESS':
      return action.getCompanyLogo;
    case 'GET_COMPANY_LOGO_FAILURE':
      return '';
    default:
      return state;
  }
};

const defaultRowTemplate = [];
const rowTemplate = (state = defaultRowTemplate, action) => {
  switch (action.type) {
    case 'GET_ROW_TEMPLATE_SUCCESS':
      return action.rowTemplate;
    case 'GET_ROW_TEMPLATE_FAILURE':
      return [];
    default:
      return state;
  }
};

export default combineReducers({
  companiesLoading,
  deleteCompanyID,
  deleteCompanyShow,
  deleteEnterpriseShow,
  deleteEnterpriseID,
  addCompanyShow,
  addCompanyGroupShow,
  addEnterpriseGroupShow,
  addedCompany,
  getAllEmailCompany,
  editCompanyShow,
  editCompanyData,
  addCompanyGroupChange,
  addEnterpriseGroupChange,
  editCompanyGroupShow,
  editEnterpriseGroupShow,
  editCompanyGroupData,
  filterByCompanyGroupManager,
  companyAgency,
  getLogo,
  rowTemplate,
  filterBySupportEngineer,
  editEnterpriseGroupData,
  companyPriBoxes,
  companySipBoxes
});
